import { FC, SVGProps } from 'react'

export const TrendingUp: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12 7.75C12 7.33579 12.3358 7 12.75 7H20.75C21.1642 7 21.5 7.33579 21.5 7.75V14.95C21.5 15.3642 21.1642 15.7 20.75 15.7C20.3358 15.7 20 15.3642 20 14.95V9.43402L13.2517 15.5075C12.9665 15.7642 12.5335 15.7642 12.2483 15.5075L8.75001 12.359L3.25173 17.3075C2.94385 17.5846 2.46963 17.5596 2.19254 17.2517C1.91544 16.9438 1.9404 16.4696 2.24828 16.1925L8.24828 10.7925C8.53351 10.5358 8.9665 10.5358 9.25173 10.7925L12.75 13.941L18.7955 8.5H12.75C12.3358 8.5 12 8.16421 12 7.75Z"
			fill="currentColor"
		/>
	</svg>
)
